import { Box, IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import { PlugConnected24Regular } from '@/components/Icon'
import AiAskBarAttachAction from './AiAskBarAttachAction'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import styles from './index.module.scss'

/** Landing composer, left of the toolbar: attach. */
export default function AiAskBarLandingLeftActions({ vm, actions }) {
  return (
    <Box className={styles.leftActions}>
      <AiAskBarAttachAction
        disabled={vm.attachments.length >= MAX_MESSAGE_ATTACHMENTS}
        onUpload={actions.handleOpenFilePicker}
        onSelectFromDocuments={actions.handleOpenDocumentsPicker}
      />
      <Tooltip text="open connections" placement="bottom">
        <IconButton
          ref={vm.connectionsButtonRef}
          type="button"
          className={styles.circleAction}
          aria-label="Open Connections"
          onClick={() => vm.setConnectionsOpen(true)}
        >
          <PlugConnected24Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
